/**
 * @generated SignedSource<<617855ec21de464b6fa2c4294ef59e04>>
 * @relayHash 835cf47f6749ab86fa6fd796e566b197
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e046b4c1327a28b7d4c765a0380da862200507908d5b6a7b0d1bf782e0a87057

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useIsAutodevEnabledQuery$variables = {
  atlassianAccountId: string;
  cloudId: string;
  isAutodevBetaEnabled: boolean;
};
export type useIsAutodevEnabledQuery$data = {
  readonly devai_rovoDevAgentsUser?: {
    readonly hasProductAccess: boolean | null | undefined;
    readonly isAdmin: boolean | null | undefined;
  };
  readonly jira: {
    readonly isRovoEnabled?: boolean | null | undefined;
  } | null | undefined;
};
export type useIsAutodevEnabledQuery = {
  response: useIsAutodevEnabledQuery$data;
  variables: useIsAutodevEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "atlassianAccountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isAutodevBetaEnabled"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "args": [
    {
      "kind": "Variable",
      "name": "atlassianAccountId",
      "variableName": "atlassianAccountId"
    },
    (v1/*: any*/)
  ],
  "concreteType": "DevAiUser",
  "kind": "LinkedField",
  "name": "devai_rovoDevAgentsUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasProductAccess"
    },
    {
      "kind": "ScalarField",
      "name": "isAdmin"
    }
  ]
},
v3 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "condition": "isAutodevBetaEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            (v1/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "isRovoEnabled"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsAutodevEnabledQuery",
    "selections": [
      {
        "condition": "isAutodevBetaEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v2/*: any*/),
            "action": "THROW",
            "path": "devai_rovoDevAgentsUser"
          }
        ]
      },
      (v3/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsAutodevEnabledQuery",
    "selections": [
      {
        "condition": "isAutodevBetaEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v2/*: any*/)
        ]
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "id": "e046b4c1327a28b7d4c765a0380da862200507908d5b6a7b0d1bf782e0a87057",
    "metadata": {},
    "name": "useIsAutodevEnabledQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "35a2fac16cf075dfe6102fcdda3a7299";

export default node;
